import { styled } from '@mui/material';
import { StyledWrapperSelectBox } from '../styles';

export const StyledAssetSelectorWrapper = styled(StyledWrapperSelectBox)`
  order: 1;
  .asset-selector {
    width: 231px;
    height: 51px;
    overflow: hidden;
    background-color: #fff;
    .MuiSelect-select {
      width: 231px;
      overflow: hidden;
    }
    .MuiStack-root {
      display: flex;
      align-items: center;
      max-width: 175px;
      span {
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .MuiAvatar-square {
      width: 32px;
      height: 32px;
      background: none;
    }
    .MuiSelect-icon {
      margin-left: 10px;
    }
  }

  #AssetSelector .asset-title {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: '#1A2332';
  }
`;
